import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { reducer as routerReducer, saga as routerSaga } from '../routes/router';
import { routesMap } from '../routes/routes';
import { rootSaga } from '../sagas/rootSaga';
import appReducer from './appSlice';
import billingReducer from './billingSlice';
import cartReducer from './cartSlice';
import checkoutReducer from './checkoutSlice';
import eduStatusReducer from './eduSlice';
import paymentReducer from './paymentSlice';
import trialReducer from './trialSlice';

const sagaMiddleware = createSagaMiddleware({
  onError: (error, { sagaStack }) => {
    console.error(error, sagaStack);
    Sentry.captureException(error, { extra: { sagaStack } });
  },
});
const history = createBrowserHistory();

export const store = configureStore({
  reducer: {
    app: appReducer,
    billing: billingReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    eduStatus: eduStatusReducer,
    payment: paymentReducer,
    routing: routerReducer,
    trial: trialReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(
      sagaMiddleware,
    ),
});

sagaMiddleware.run(routerSaga, routesMap, history);
sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
